
import { defineComponent } from 'vue';

interface DataState {
  prompt: string;
}

export default defineComponent({
  props: {
    aiLabel: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data(): DataState {
    return {
      prompt: '',
    };
  },
  methods: {
    onSubmit() {
      this.$emit('prompt', {
        role: 'user',
        content: this.prompt,
      });
      this.prompt = '';
    },
  },
});
